export default {
      id: "reaction-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "sprite-46b249.svg#reaction-usage",
      toString: function () {
        return this.url;
      }
    }